<button (click)="newCommentClicked($event)" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
  <i class="fal fa-comment-alt"></i>
  <span [class.hideTextMobile]="hideTextMobile">&nbsp;Kommentieren</span>
  <span *ngIf="comment_count > 0">&nbsp;({{ comment_count }})</span>
</button>
